import { LocalStorage } from "storage"

export const getSiteCode = () => {
  let path: string = window.location.pathname
  let split: string[] = path.split("/")
  return split[split.length - 1]
}

export const getReduxStore = () => {
  let reduxStore = null

  const reduxContext: string = LocalStorage().retrieve("tfDriverConfig") || ""
  if (reduxContext !== "") reduxStore = JSON.parse(reduxContext)

  return reduxStore
}

export const setReduxStore = (reduxStore: any) => {
  LocalStorage().store("tfDriverConfig", JSON.stringify(reduxStore))
}

export const clearReduxStore = () => {
  LocalStorage().remove("tfDriverConfig")
}

export const checkModuleAndSource = (
  modules: any,
  moduleName: string,
  sourceName: string
) => {
  let module = modules.find((x: any) => x.name == moduleName)

  if (module == null || module == undefined) {
    return false
  }

  let s = module.sources.find((x: any) => x == sourceName)

  if (s == null || s == undefined) {
    return false
  }

  return true
}
